<template>
    <div>
        <el-upload
                action="/common/fileUpload"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :headers="headers"
                :data="data"
                :limit="limitCount"
                :file-list="fileUploadList"
                :show-file-list="showFileList"
                :disabled="disabled"
                :on-success="handleSuccess">
            <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'upload',
        props: {
            limit: {
                type: Number,
                default: 1,
                required: false
            },
            fileList: {
                type: Array,
                default: null,
                required: false
            }
        },
        data() {
            return {
                imageBaseUrl:"/common/getImageById?fileId=",
                disabled:false,
                showFileList:true,
                fileUploadList: this.fileList === null ? [] : this.fileList,
                limitCount: 2,
                dialogImageUrl: '',
                dialogVisible: false,
                headers: {"X-Token": this.$store.state.token},
                data: {"userId": this.$store.state.userId, "sysId": this.$store.state.sysId}
            };
        },
        methods: {
            handleRemove(file, fileList) {
                for (let index in this.fileUploadList){
                    let obj = this.fileUploadList[index];
                    if (obj.id === file.id){
                        this.fileUploadList.splice(index,1);
                        break;
                    }
                }
                this.$emit("update:fileList", this.fileUploadList);
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleSuccess(response, file, fileList) {
                if (response.code === 200) {
                    if(this.fileUploadList.length>=this.limit){
                        this.fileUploadList.splice(0,1);
                    }
                    var obj = {};
                    obj.url = this.imageBaseUrl + response.data.fileId;
                    obj.name =  response.data.fileName;
                    obj.id = response.data.fileId;
                    this.fileUploadList || (this.fileUploadList = []);
                    this.fileUploadList.push(obj);
                    this.$emit("update:fileList", this.fileUploadList);
                }
            }
        }
    }
</script>

<style scoped>

</style>